<template>
  <div class="container-fluid font-family-avenir-bold">
    <div id="carousel-widget-slide">
      <VueSlickCarousel v-bind="settings">
        <template #nextArrow>
          <button type="button" class="custom-arrow-next"><span class="png-icon png-icon-icons-glyph--k-chevron-right"></span></button>
        </template>
        <template #prevArrow>
          <button type="button" class="custom-arrow-prev"><span class="png-icon png-icon-icons-glyph--k-chevron-left"></span></button>
        </template>
        <div
          v-for="(item, index) in imageData"
          :key="index"
          class="text-center image-caption"
        >
          <img class="widget-img-view" v-if="item.image" :src="resolveImageUrl(item.image)" alt="img" @error="handleImageError" />

          <a v-if="item.url"
            class="font-size-18 text-decoration-none text-reset"
            :href="item.url"
            :target="item.openInNewTab == true ? '_blank' : '_self'"
          >
            {{ item.title }}
            <span
              class="png-icon png-icon-icons-glyph--k-chevron-right"
            ></span>
          </a>
        </div>
      </VueSlickCarousel>
    </div>
  </div>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import { globalIcons } from "../../constants/global";
export default {
  props: ["imageData"],
  components: {
    VueSlickCarousel
  },
  data() {
    return {
      settings: {
        centerMode: false,
        centerPadding: "8px",
        speed: 900,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      },
      defaultImage:globalIcons.defaultImage
    };
  },
  methods:{
    resolveImageUrl(imageUrl) {
      if (imageUrl.startsWith('~')) {
        return imageUrl.substr(1);
      } else {
        return imageUrl;
      }
    },
    handleImageError(event) {
      event.target.src = this.defaultImage;
    },
  }
};
</script>
